var _circle, _path, _path2, _path3, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpirence4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 56,
    fill: "url(#paint0_angular_22302_13271)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.5 71L95.8895 75.5L101 76.121L97.25 79.5005L98 84.5L93.5 81.6875L89 84.5L89.75 79.5005L86 76.121L91.25 75.5L93.5 71Z",
    fill: "#02665B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89 101H86V93.5C85.9977 91.5116 85.2067 89.6053 83.8007 88.1993C82.3947 86.7933 80.4884 86.0023 78.5 86H69.5C67.5116 86.0023 65.6053 86.7933 64.1993 88.1993C62.7933 89.6053 62.0023 91.5116 62 93.5V101H59V93.5C59.0033 90.7162 60.1105 88.0474 62.079 86.079C64.0474 84.1105 66.7162 83.0033 69.5 83H78.5C81.2838 83.0033 83.9526 84.1105 85.921 86.079C87.8895 88.0474 88.9967 90.7162 89 93.5V101Z",
    fill: "#02665B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74 62C75.4834 62 76.9334 62.4399 78.1668 63.264C79.4001 64.0881 80.3614 65.2594 80.9291 66.6299C81.4968 68.0003 81.6453 69.5083 81.3559 70.9632C81.0665 72.418 80.3522 73.7544 79.3033 74.8033C78.2544 75.8522 76.918 76.5665 75.4632 76.8559C74.0083 77.1453 72.5003 76.9968 71.1299 76.4291C69.7594 75.8614 68.5881 74.9001 67.764 73.6668C66.9399 72.4334 66.5 70.9834 66.5 69.5C66.5 67.5109 67.2902 65.6032 68.6967 64.1967C70.1032 62.7902 72.0109 62 74 62ZM74 59C71.9233 59 69.8932 59.6158 68.1665 60.7696C66.4398 61.9233 65.094 63.5632 64.2993 65.4818C63.5045 67.4004 63.2966 69.5116 63.7018 71.5484C64.1069 73.5852 65.1069 75.4562 66.5754 76.9246C68.0438 78.3931 69.9148 79.3931 71.9516 79.7982C73.9884 80.2034 76.0996 79.9955 78.0182 79.2007C79.9368 78.406 81.5767 77.0602 82.7304 75.3335C83.8842 73.6068 84.5 71.5767 84.5 69.5C84.5 66.7152 83.3938 64.0445 81.4246 62.0754C79.4555 60.1062 76.7848 59 74 59Z",
    fill: "#02665B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 158,
    height: 158,
    rx: 79,
    stroke: "#0CD66E",
    strokeOpacity: 0.24,
    strokeWidth: 2,
    strokeDasharray: "4 4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_22302_13271",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(80 80) scale(56)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CD66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69F290"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpirence4);
export default __webpack_public_path__ + "static/media/expirence4.6259e75c7dca9c0f24a2e813a9fd8a6c.svg";
export { ForwardRef as ReactComponent };